import { render } from "./Home.vue?vue&type=template&id=4b27eae2&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.styles.css?vue&type=style&index=0&id=4b27eae2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b27eae2"]])

export default __exports__